export default __webpack_public_path__ + "static/taxi-cfa7b3f3d795931783ebc830bc8765d4.svg";